define('core/extensions/helpers/log',[],function () {
    'use strict';

    /* eslint-disable no-console */
    // Log helper for development only
    return function (name) {
        console.log(name, this);
    };
});

